import {Image, ImageProps} from '@chakra-ui/react';

import cashIcon from './cash-icon.png';

export const CashIcon = (props: ImageProps) => <Image src={cashIcon.src} alt="" objectFit="contain" {...props} />;
